import {StockAPI} from "@/api/StockAPI";
import {ProductAPI} from "@/api/ProductAPI";
import Vue from "vue";

function StocksRender(required = true, ssRequired = false, multipleSubstocks = false, ssSticky = true) {
    return {
        stockId: {
            icon: '$stock',
            required: required,
            sticky: required,
            autocomplete: {
                callFn: () => StockAPI.getAllPages(),
                thenFn: response => response.data.items.map(el => ({
                    text: el.name,
                    value: el.id
                }))
            }
        },
        subStockId: {
            icon: '$substock',
            required: ssRequired,
            sticky: ssSticky,
            autocomplete: {
                items: [],
                multiple: multipleSubstocks,
                chips: multipleSubstocks
            }
        }
    };
}

function ProductIdRender() {
    return {
        sticky: true,
        autocomplete: {
            callFn: () => ProductAPI.getVisibleAllPages(),
            thenFn: response => response.data.items.map(el => ({
                ...el,
                value: el.id
            })),
            render: item => item.text || Vue.options.filters.productLabel(item)
        }
    };
}

function InstanceIdRender() {
    return {
        sticky: true,
        show: false,
        autocomplete: {items: []}
    };
}

export {StocksRender, ProductIdRender, InstanceIdRender};
